import axios from "@/common/http";

export default {
  state: () => ({
    singleImageIntegral: 10, // 单张图片积分
    subscribeGear: {}, // 服装商拍订阅商品
    payLoading: false, // 支付loading
    vipExtraList: [], // 会员流量包列表
  }),
  mutations: {
    setSubscribeGear(state, data) {
      state.subscribeGear = data;
    },
    setPayLoading(state, data) {
      state.payLoading = data;
    },
    setVipExtraList(state, data) {
      state.vipExtraList = data;
    },
  },
  actions: {
    // 获取服装商拍订阅商品
    async getProductList({ commit }) {
      const data = {
        product_type: 1,
        ai_works_type: 6,
        subscribe_type: 0,
        chn: "web",
      };
      const res = await axios.post("/v1/product/list", data);
      console.log(commit);
      if (res.status === "200") {
        const categorizedProducts = res.data.list.reduce((result, product) => {
          const category = product.product_category;
          if (!result[category]) {
            result[category] = [];
          }
          result[category].push(product);
          return result;
        }, {});
        commit("setSubscribeGear", categorizedProducts);
      }
      return res;
    },
    // 订阅订单 - 订单详情接口
    async getOrderDetailList({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/points/getorderdetaillist", data);
      return res;
    },
    // 创建支付订单
    async createOrder({ state }, data) {
      state.payLoading = true;
      const res = await axios.post("/v1/order/create", data);
      state.payLoading = false;
      return res;
    },
    // 获取订单状态
    async getOrderStatus({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/order/detail", data);
      return res;
    },
    // 获取会员流量包列表
    async getVipExtraList({ state }, product_id) {
      state.payLoading = true;
      const data = {
        product_id,
      };
      const res = await axios.post("/v1/product/vip_extra_list", data);
      state.payLoading = false;
      if (res.status === "200") {
        state.vipExtraList = res.data.list;
      }
      return res;
    },
  },
  getters: {},
};
